/* eslint-disable @typescript-eslint/no-use-before-define */
import { useStore } from "@nanostores/preact"
import { JSX } from "preact"

import caretLeft from "static/icons/caret-left.svg"

import css from "./style.module.scss"
import { LoadingScreen } from "./screens/LoadingScreen"
import { ErrorScreen } from "./screens/ErrorScreen"
import { OffersScreen } from "./screens/OffersScreen"
import { SignUpScreen } from "./screens/SignUpScreen"
import { $supportLoadingStates } from "./hooks/support"
import { PaymentScreen } from "./screens/PaymentScreen"
import { SignInScreen } from "./screens/SignInScreen"
import { ForgotScreen } from "./screens/ForgotPassword"
import { SuccessScreen } from "./screens/SuccessScreen"
import { goBack, useCanGoBack, useNavigation } from "./hooks/navigation"
import { $user } from "./hooks/user"
import { t } from "./hooks/translations"
import { WeatherSummary } from "./components/WeatherSummary"

type AppProps = {
  close: () => void
}

export const App = function App({ close }: AppProps) {
  const { screen } = useNavigation()

  const { fulfilled, loading, error } = useStore($supportLoadingStates)

  const canGoBack = useCanGoBack()

  let activeScreen: JSX.Element
  if (error != null) {
    activeScreen = <ErrorScreen error={error} />
  } else if (loading || !fulfilled) {
    activeScreen = <LoadingScreen />
  } else {
    switch (screen) {
      case "Error":
        activeScreen = <ErrorScreen error={error} />
        break
      case "Loading":
        activeScreen = <LoadingScreen />
        break
      case "Offers":
        activeScreen = <OffersScreen />
        break
      case "SignUp":
        activeScreen = <SignUpScreen />
        break
      case "SignIn":
        activeScreen = <SignInScreen />
        break
      case "ForgotPassword":
        activeScreen = <ForgotScreen />
        break
      case "Payment":
        activeScreen = <PaymentScreen />
        break
      case "Success":
        activeScreen = <SuccessScreen />
        break
      default:
        throw new Error(`setting the active screen, but it is unknown (${activeScreen})`)
    }
  }

  return (
    <div className={css.backdrop}>
      <div className={css.modal}>
        <div className={css.header}>
          {canGoBack && (
            <button type="button" className={css.back} onClick={() => goBack()}>
              <img src={caretLeft} alt="Back" width={12} className={css["back-icon"]} />
              {t("back")}
            </button>
          )}
          <button
            type="button"
            className={css.close}
            onClick={() => {
              if ($user.get().paymentDone) {
                window.location.reload()
              } else {
                close()
              }
            }}
          >
            {t("close")} <span className={css["close-icon"]}>✕</span>
          </button>
        </div>
        <div className={css.container}>{activeScreen}</div>
      </div>
    </div>
  )
}

type IncentiveAppProps = {
  onOpen: () => void
}

export const IncentiveApp = function IncentiveApp({ onOpen }: IncentiveAppProps) {
  const { fulfilled, error, loading } = useStore($supportLoadingStates)

  if (error != null) {
    return (
      <div className={css.container}>
        <ErrorScreen error={error} />
      </div>
    )
  }

  if (loading || !fulfilled) {
    return (
      <div className={css.container}>
        <LoadingScreen />
      </div>
    )
  }

  return (
    <div className={css.container}>
      <WeatherSummary />
      <OffersScreen onClick={onOpen} />
    </div>
  )
}
